module.exports = __webpack_public_path__ + "static/AW_cartoon-392936feffa1cef4a68b2c723609f2d6.jpg";